module.exports = __webpack_public_path__ + "static/media/4_r_krilo_78.39_69.72.50737e39.png";